export default __webpack_public_path__ + "2de228697d425606822d3368bcfe4f07.jpg";